import * as React from "react";

const SicunetMobileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#0041C0"
      d="m16.047 4.792-9 13.948 4.137 2.141 9-13.949zM12.308 21c.264-.036.502-.111.73-.227q3.461-1.792 6.923-3.576c.641-.334 1.039-.948 1.039-1.612v-7.15c0-.241-.045-.46-.144-.682Q16.58 14.373 12.308 21M3 11.137v4.444c0 .663.398 1.278 1.04 1.612.7.36 1.402.726 2.103 1.086l2.67-4.14c-1.94-.998-3.874-2-5.813-3.002M11.95 9.276 5.62 6.003l-1.58.815C3.397 7.152 3 7.766 3 8.43v1.634q3.169 1.636 6.33 3.273 1.314-2.03 2.62-4.061M15.144 4.334c-.701-.361-1.402-.726-2.103-1.087a2.31 2.31 0 0 0-2.079 0L6.661 5.47q2.903 1.504 5.813 3.001c.89-1.38 1.775-2.76 2.67-4.136"
    ></path>
    <path
      fill="#0041C0"
      d="m16.047 4.792-9 13.948 4.137 2.141 9-13.949zM12.308 21c.264-.036.502-.111.73-.227q3.461-1.791 6.923-3.576c.641-.334 1.039-.948 1.039-1.611V8.435c0-.24-.045-.46-.144-.682Q16.58 14.373 12.308 21M3 11.137v4.444c0 .663.398 1.278 1.04 1.612.7.36 1.402.726 2.103 1.086l2.67-4.14c-1.94-.998-3.874-2-5.813-3.002M11.95 9.276 5.62 6.003l-1.58.815C3.397 7.152 3 7.767 3 8.43v1.634q3.169 1.637 6.33 3.273 1.314-2.03 2.62-4.061M15.144 4.334c-.701-.361-1.402-.726-2.103-1.087a2.31 2.31 0 0 0-2.079 0L6.661 5.47q2.903 1.504 5.813 3.001c.89-1.38 1.775-2.76 2.67-4.136"
    ></path>
  </svg>
);

export default SicunetMobileIcon;
